import React from 'react'
import { LayoutClient } from './layout/LayoutClient'



export const ClientScreen = () => {
    return (
        <LayoutClient />
    )
}
